// types
import { ConfigProps } from 'types/config';

export const FIREBASE_API = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID
};

export const APP_DOMAIN = process.env.REACT_APP_DOMAIN;

export const STYRK_API = process.env.REACT_APP_STYRK_API;

export const AUTH_SAML_LOGIN = process.env.REACT_APP_AUTH_SAML_LOGIN;
export const AUTH_GOOGLE_LOGIN = process.env.REACT_APP_AUTH_GOOGLE_LOGIN === 'true' ? true : false;
export const AUTH_METHOD = process.env.REACT_APP_AUTH_METHOD || 'email-password';

export const VADEMECUM_URL = process.env.REACT_APP_VADEMECUM_URL;

export const BASE_PATH = '';

export const DASHBOARD_PATH = '/loolu/admin/health-content/overall-score';

export const SIZE_BUCKET = process.env.REACT_APP_SIZE_BUCKET || '1099511627776';
/* 1099511627776 bytes = 1TB Multiplicar este numero para obtener la cantidad de TB requeridos */

export const DISABLE_VENDOR_ADD = !!process.env.REACT_APP_DISABLE_VENDOR_ADD;

const config: ConfigProps = {
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'dark',
    presetColor: 'default',
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false
};

export default config;
